import { render } from "./BookDetailsLeftPanel.vue?vue&type=template&id=7a84037a&scoped=true"
import script from "./BookDetailsLeftPanel.vue?vue&type=script&lang=js"
export * from "./BookDetailsLeftPanel.vue?vue&type=script&lang=js"

import "./BookDetailsLeftPanel.vue?vue&type=style&index=0&id=7a84037a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a84037a"]])

export default __exports__